import Privacy from '@/views/contracts/privacy/Privacy.vue';

export default {
  path: '/privacy',
  name: 'Privacy',
  component: Privacy
};
